@if (isOpened() || alwaysRender) {
  <div class="modal-wrapper position-fixed" [class.d-none]="alwaysRender && !isOpened()">
    <div
      class="modal-wrapper__inner c-bg-gray-100 {{ compact ? 'p-16' : 'p-32' }} position-relative d-flex flex-direction-column large-border-radius"
      [class.p-16]="compact"
      [style.max-width]="maxWidth"
      [style.min-width]="minWidth"
      [style.width]="width"
      [style.height]="height"
      [style.aspect-ratio]="aspectRatio"
    >
      @if (compact) {
        @if (title) {
          <div class="d-flex align-items-center gap-16">
            @if (showBackButton) {
              <button
                class="icon-button sm c-t-gray-700"
                type="button"
                (click)="backButtonClick.emit()"
              >
                <i class="ri-arrow-left-line"></i>
              </button>
            }

            <h4 class="text-center text-uppercase">{{ title }}</h4>

            @if (textAfterTitle) {
              <div class="h4 fw-semibold left-separator p-l-16 c-t-blue-500">{{ textAfterTitle }}</div>
            }
          </div>
        }
      } @else {
        <div class="d-flex align-items-center gap-24 justify-content-space-between">
          @if (title) {
            <div class="d-flex align-items-center gap-16">
              @if (showBackButton) {
                <button
                  class="icon-button sm c-t-gray-700"
                  type="button"
                  (click)="backButtonClick.emit()"
                >
                  <i class="ri-arrow-left-line"></i>
                </button>
              }

              <h4 class="text-center text-uppercase h2">{{ title }}</h4>

              @if (textAfterTitle) {
                <div class="h2 fw-semibold left-separator p-l-16 c-t-blue-500">{{ textAfterTitle }}</div>
              }
            </div>
          }
        </div>
      }

      <ng-content select="[modal-precontent]" />

      <div class="flex-grow-1 {{ title ? compact ? 'm-t-8' : 'm-t-32' : '' }} d-flex flex-direction-column overflow-auto">
        <app-scrollable-wrapper [isGrowing]="false">
          <ng-container [ngTemplateOutlet]="modalContent" />
        </app-scrollable-wrapper>
      </div>

      <ng-content select="[modal-buttons]" />
    </div>
  </div>
}
